import React from "react"
import {
    LoadingOrErrorContainer,
    VerticalStackStretch,
} from "@mallardbay/lib-react-components"

import { TEST_IDS } from "~config/test-ids"
import LodgingsCollectionWithModal from "~components/shared/collections/lodgings-collection-with-modal"
import useLodgingsByListing from "~utils/use-lodgings-by-listing"
import Divider from "~components/shared/divider"

interface Props {
    readonly listingId?: string
}

export default function ListingLodgings({ listingId }: Props) {
    const { lodgings, isLoading, error } = useLodgingsByListing(listingId)
    const shouldRender = isLoading || lodgings.length > 0

    return (
        <LoadingOrErrorContainer
            error={error}
            shouldRenderChildren={shouldRender}
        >
            <VerticalStackStretch>
                <LodgingsCollectionWithModal
                    testId={TEST_IDS.LISTING_LODGINGS}
                    lodgings={lodgings}
                    isLoading={isLoading}
                />
                <Divider />
            </VerticalStackStretch>
        </LoadingOrErrorContainer>
    )
}
